// Translate editor language tags and the historical "gb" value to Google language codes.
const SUPPORTED = ['de', 'en', 'it', 'fr', 'pt', 'nl', 'bg']

export function placesLanguage(code) {
  const raw = typeof code === 'string' ? code.trim().toLowerCase() : ''
  if (!raw) return 'en'
  if (raw === 'gb') return 'en-GB'
  if (SUPPORTED.includes(raw)) return raw
  const [base, region] = raw.split(/[-_]/)
  if (base === 'en' && region === 'gb') return 'en-GB'
  if (SUPPORTED.includes(base)) return base
  return 'en'
}
